import axios from 'axios'

// ACTION TYPES
const name = 'data'
export const actionTypes = {
  LOAD_PERFORMANCE: `${name}:load_performance`,
  LOAD_DATA_STATUS: `${name}:load_performance_status`,
  LOAD_LISTING: `${name}:load_listing`,
  LOAD_LISTING_STATUS: `${name}:load_listing_status`,
  LOAD_PERFORMANCE_FUTURE: `${name}:load_performance_future`,
  // LOAD_PERFORMANCE_FUTURE_STATUS: `${name}:load_performance_future_status`,
  SET_PERF_START_DATE: `${name}:set_perf_start_date`,
  SET_PERF_END_DATE: `${name}:set_perf_end_date`,
  SET_ENTITY: `${name}:set_entity`,
  SET_ENTITY_FUTURE: `${name}:set_entity_future`,
  SET_PERIOD: `${name}:set_period`,
  SET_RANGE: `${name}:set_range`,
  SET_RANGE_FUTURE: `${name}:set_range_future`,
  SET_RANGE_OPTIONS: `${name}:set_range_options`,
  SET_RANGE_OPTIONS_FUTURE: `${name}:set_range_options_future`,
  SET_EARNINGS_TYPE: `${name}: set_earnings_type`,
  SET_GROWTH_TYPE: `${name}: set_growth_type`,
  SET_EARNINGS_PERIOD: `${name}: set_earnings_period`,
  SET_SELECTED_CHARS: `${name}: set_selected_chars`,
  SET_CONSTITUENT_NUMBER: `${name}: set_constituent_number`,
  FILTER_PERIOD_DATA: `${name}:filter_period_data`,
  FILTER_RANGE_DATA: `${name}:filter_range_data`,
  RESET_LOAD_STATUS_FUTURE: `${name}:reset_load_status_future`,
  RESET_LOAD_STATUS: `${name}:reset_load_status`,

}

// ACTIONS
export function loadPerformance() {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.RESET_LOAD_STATUS, value: false })
    var ticker = ''
    const date = getState().params.date
    const initialTicker = getState().params.ticker
    let selectedTicker = getState().data.selectedEntityOption[0]

    if (typeof selectedTicker === 'string') {
      let x = selectedTicker.split(' - ')
      ticker = x[0]
    } else {
      ticker = initialTicker
    }
    let url = `${process.env.REACT_APP_API_URL}/data`
    const request = {
      method: 'GET',
      url: url,
      params: {
        divisionId: getState().params.divisionId,
        wtRegion: getState().params.wtRegion,
        isoCode: getState().params.isoCode,
        isFP: getState().params.isFP,

        ticker: ticker,
        date: date
      }
    }
    return axios(request)
      .then(response => {
        // console.log('REQUEST-current', request)
        // console.log('RESPONSE-current', response)
        dispatch({ type: actionTypes.LOAD_PERFORMANCE, value: response.data })
        dispatch({ type: actionTypes.LOAD_DATA_STATUS, value: 'current' })
        dispatch({ type: actionTypes.RESET_LOAD_STATUS, value: true })
      })
      .catch(error => {
        console.error(error)
      })
  }
}
// gets a list of entities to be used in select for options 
export function loadListing() {

  return (dispatch, getState) => {
    dispatch({ type: actionTypes.RESET_LOAD_STATUS, value: false })
    const date = getState().params.date
    let url = `${process.env.REACT_APP_API_URL}/data_listing`
    const request = {
      method: 'GET',
      url: url,
      params: {
        date: date
      }
    }
    return axios(request)
      .then(response => {
        // console.log('REQUEST-LISTING', request)
        // console.log('RESPONSE-LISTING', response)
        dispatch({ type: actionTypes.LOAD_LISTING, value: response.data })
        dispatch({ type: actionTypes.LOAD_DATA_STATUS, value: 'listing' })

      })
      .catch(error => {
        console.error(error)
      })
  }
}
//Load future data
export function loadPerformanceFuture() {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.RESET_LOAD_STATUS_FUTURE, value: false })

    const date = getState().params.date
    const initialTicker = getState().params.ticker_future
    let selectedTicker = getState().data.selectedEntityOptionFuture  //this is an array

    let ticker;

    if (Array.isArray(selectedTicker)) {
      // If selectedTicker is an array, map each item to its first part before ' - '
      ticker = selectedTicker.map(item => item.split(' - ')[0]);
    } else if (typeof selectedTicker === 'string') {
      // If selectedTicker is a string, split it by ' - ' and take the first part
      ticker = [selectedTicker.split(' - ')[0]];
    }

    // If ticker is an empty array or contains an empty string, use initialTicker
    if (ticker.length === 0 || ticker[0] === '') {
      ticker = [initialTicker];
    }

    // Convert ticker array to a comma-separated string
    ticker = ticker.join(',');

    let url = `${process.env.REACT_APP_API_URL}/data_aggs`;
    const request = {
      method: 'GET',
      url: url,
      params: {
        date: date
      }
    }
    axios(request)
      .then(response => {
        //console.log('REQUEST-FUTURE', request)
        //console.log('RESPONSE-FUTURE', response)
        dispatch({ type: actionTypes.LOAD_PERFORMANCE_FUTURE, value: response.data })
        dispatch({ type: actionTypes.LOAD_DATA_STATUS, value: 'future' })
        dispatch({ type: actionTypes.RESET_LOAD_STATUS_FUTURE, value: true })
      })
      .catch(error => {
        console.error(error)
      })
  }
}

export function setEntity(entity) {
  return dispatch => {
    const selected = entity.value
    dispatch({ type: actionTypes.SET_ENTITY, value: selected })
    dispatch(loadPerformance())
  }
}


export function setEntityFuture(entity) {
  return dispatch => {
    // No need to map, as entity is already an array of strings
    const selected = entity.map(i => i.value);
    dispatch({ type: actionTypes.SET_ENTITY_FUTURE, value: selected });

  }
}



export function setPeriod(period) {
  return dispatch => {
    const selected = period.value
    const type = 'period_' + selected
    dispatch({ type: actionTypes.SET_PERIOD, value: selected })
    dispatch({ type: actionTypes.SET_RANGE_OPTIONS, value: type })
  }
}

export function setRange(range) {
  return dispatch => {
    const selected = range.value
    const type = 'range_' + selected
    dispatch({ type: actionTypes.SET_RANGE, value: selected })
    dispatch({ type: actionTypes.SET_RANGE_OPTIONS, value: type })
  }
}

export function setRangeFuture(range) {
  return dispatch => {
    const selected = range.value
    const type = 'range_' + selected
    dispatch({ type: actionTypes.SET_RANGE_FUTURE, value: selected })
    dispatch({ type: actionTypes.SET_RANGE_OPTIONS_FUTURE, value: type })
  }
}
export function setEarningsType(value) {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SET_EARNINGS_TYPE, payload: value })
  }
}

export function setGrowthType(value) {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SET_GROWTH_TYPE, payload: value })
  }
}

export function setConstituentNumber(value) {
  return (dispatch, getState) => {
    dispatch({ type: actionTypes.SET_CONSTITUENT_NUMBER, payload: value })
  }
}

/* sets list of chars to display series chart data */
export function setSelectedChars(value) {
  return dispatch => {
    dispatch({ type: actionTypes.SET_SELECTED_CHARS, payload: value })
  }
}



// WEBPACK FOOTER //
// ./src/actions/data.js